import { render } from "./TermsAndConditions.vue?vue&type=template&id=0f0c9f2c"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__